/*
 * @Author: Ryan
 * @Date: 2026-01-08
 * @Description: 视频翻译 Landing 页面配置
 */

import { LanguageCode } from '@/hooks/useTranslationConfig';

// 功能页跳转路径
export const VIDEO_TRANSLATOR_URL = '/video-translator';

export interface LandingPageConfig {
  slug: string;
  jsonFileName: string;
  sourceLanguage: LanguageCode;
  targetLanguage: LanguageCode;
}

// 所有 Landing 页面配置
export const LANDING_PAGES: LandingPageConfig[] = [
  {
    slug: 'spanish-to-english',
    jsonFileName: 'spanish-to-english.json',
    sourceLanguage: 'es',
    targetLanguage: 'en',
  },
  {
    slug: 'chinese-to-english',
    jsonFileName: 'chinese-to-english.json',
    sourceLanguage: 'zh',
    targetLanguage: 'en',
  },
  {
    slug: 'french-to-english',
    jsonFileName: 'french-to-english.json',
    sourceLanguage: 'fr',
    targetLanguage: 'en',
  },
  {
    slug: 'arabic-to-urdu',
    jsonFileName: 'arabic-to-urdu.json',
    sourceLanguage: 'ar',
    targetLanguage: 'ur',
  },
  {
    slug: 'arabic-to-english',
    jsonFileName: 'arabic-to-english.json',
    sourceLanguage: 'ar',
    targetLanguage: 'en',
  },
  {
    slug: 'english-to-spanish',
    jsonFileName: 'english-to-spanish.json',
    sourceLanguage: 'en',
    targetLanguage: 'es',
  },
  {
    slug: 'german-to-english',
    jsonFileName: 'german-to-english.json',
    sourceLanguage: 'de',
    targetLanguage: 'en',
  },
  {
    slug: 'japanese-to-english',
    jsonFileName: 'japanese-to-english.json',
    sourceLanguage: 'ja',
    targetLanguage: 'en',
  },
  {
    slug: 'korean-to-english',
    jsonFileName: 'korean-to-english.json',
    sourceLanguage: 'ko',
    targetLanguage: 'en',
  },
  {
    slug: 'russian-to-english',
    jsonFileName: 'russian-to-english.json',
    sourceLanguage: 'ru',
    targetLanguage: 'en',
  },
];

// 根据 slug 获取配置
export const getLandingConfig = (slug: string): LandingPageConfig | undefined => {
  return LANDING_PAGES.find((page) => page.slug === slug);
};

// 获取所有 slug（用于 getStaticPaths）
export const getAllSlugs = (): string[] => {
  return LANDING_PAGES.map((page) => page.slug);
};
